module.exports = __webpack_public_path__ + "static/img/web_icon.fdd14591.png";